<!--快捷 历史记录-->
<template>
    <div class="id">
        <div class="navBar" @click="$router.back()">
            <van-icon name="arrow-left" />
            {{ content.title }}
        </div>
        <div v-html="content.content" style="padding: 10px;padding-top: 0;">
        </div>
    </div>
</template>
<script>
import { get } from '@/http/request'
export default {
    components: {
    },
    data() {
        return {
            content: '',
        };
    },
    mounted() {
        this.indexData()
    },
    methods: {
        async indexData() {
            const res = await get(this.$apis.richtextGetInfo, { id: this.$route.query.id, type: this.$route.query.type })
            if (res.code == 1) {
                this.content = res.data
                return
            }
        },

    },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding: 0 15px;
    padding-top: 50px;
    font-size: 14px;

    .navBar {
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 4px;
    }

    ::v-deep .van-tabs__wrap {
        border-bottom: 1px solid #323233;
    }

    .title {
        display: flex;
        align-items: center;
        font-size: 30px;
        padding-bottom: 20px;
        padding-top: 30px;
    }

    .table {
        background: #000;
        color: #fff;
        margin-top: 10px;

        .header {
            font-weight: bold;
            background: #1c222c;
            padding: 14px 0;
            border-radius: 5px;

            .vanItem {
                text-align: center;
            }
        }

        .scroll {
            overflow-y: auto;
            height: 74vh;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE/Edge */
        }

        .row {
            border-bottom: 1px solid #222b39;
            padding: 20px 0px;
            display: flex;
            align-items: center;

            .trade {
                text-align: center;
            }
        }
    }
}
</style>
